import styled, { css } from 'styled-components'
import { Drawer as DrawerComponent } from '@sainsburys-tech/bolt'

const Drawer = styled(DrawerComponent)`
  > div:first-of-type {
    max-width: 100%;
    visibility: hidden;

    @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
      width: 100%;
    }

    ${props =>
      props.show &&
      css`
        visibility: visible;
      `}
  }

  .three_d_content {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    model-viewer {
      height: 100%;
      width: 100%;
    }
  }

  .alert {
    position: absolute;

    @media only screen and (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
      width: 400px;
      left: calc(50% - 200px);
    }
  }
`

export { Drawer } // eslint-disable-line
